export enum ProjectTypeEnums {
  Accounting = 1,
  CentralNode = 2,
  MyJack = 3,
}

export interface ProjectType {
  end_date: string | null;
  id: number;
  is_enable: number;
  project: { __typename: string; id: number; title: string; is_enable: number };
  start_date: string;
  updatedAt: string;
  error: string;
  __typename: string;
}
